import About from "../Allcomponent/about"
function Aboutmain(){
    return(
        <>
       
        <About/>
        </>
    )
}
export default Aboutmain